import { API_ROOT } from '../../config/config'
import { doGet, doPost } from './utils'

//const API_ROOT = 'http://localhost/api'

export const getSubprojectInfoDoc = (projectVersionId, projectCode) => {
  const url = `${API_ROOT}/subproject/project-info-doc?projectVersionId=${projectVersionId || ''}&projectCode=${projectCode || ''}`
  return doGet(url)
}